import { useMemo } from 'react';
import pluralize from 'pluralize';

export const getCandidatesHeader = (candidateCount) =>
  `${candidateCount?.toLocaleString()} ${pluralize('candidate', candidateCount ?? 0)}`;

export const getCandidatesColumns = ({ candidateCount = 0 }) => [
  {
    Header: getCandidatesHeader(candidateCount),
    accessor: 'candidate',
    width: 300,
    disableSortBy: true,
    hideOnTableColumn: true,
    lockPosition: 'left',
    pinned: 'left',
    cellRenderer: 'candidateNameRenderer',
    suppressMovable: true,
    valueFormatter: ({ data: { original } }) => original.firstName,
    headerStyle: { paddingLeft: '8px' },
    autoHeight: true,
    wrapText: true,
  },
  {
    Header: 'Job Title',
    accessor: 'jobTitle',
    width: 250,
    disableSortBy: true,
    hideOnTableColumn: true,
    cellRenderer: 'tableRow',
    valueFormatter: ({ data: { original } }) => original.jobTitle,
    autoHeight: true,
    wrapText: true,
  },
  {
    Header: 'Company',
    accessor: 'company',
    width: 200,
    disableSortBy: true,
    hideOnTableColumn: true,
    cellRenderer: 'candidateCompanyRenderer',
    valueFormatter: ({ data: { original } }) => original.companyName,
    autoHeight: true,
    wrapText: true,
  },
  {
    Header: 'Strengths',
    accessor: 'strengths',
    flex: 1,
    disableSortBy: true,
    hideOnTableColumn: true,
    cellRenderer: 'campaignStrengthsRenderer',
    valueFormatter: ({ data: { original } }) => original.context,
    autoHeight: true,
    wrapText: true,
  },
];

export const useCandidatesTableRows = ({ candidates }) =>
  useMemo(
    () =>
      candidates.map((candidate, index) => ({
        id: `candidate-${index}`,
        index,
        candidate,
        jobTitle: candidate.jobTitle,
        company: candidate.companyName,
        strengths: candidate.context,
        original: candidate,
      })),
    [candidates],
  );
